import React from "react";
import { SITE } from "../../mock/mock";
import { Instagram, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 md:py-16 grid md:grid-cols-3 gap-10">
        <div>
          <a href="#top" className="flex flex-col leading-none">
            <span className="font-serif-display text-3xl md:text-4xl text-white tracking-tight">
              Take The Stage
            </span>
            <span className="mt-2 text-[11px] tracking-[0.28em] uppercase text-white/60">
              by <span className="italic-display normal-case tracking-normal text-sm text-white/85">Michelle Fragias</span>
            </span>
          </a>
          <p className="mt-5 text-white/70 text-[14.5px] max-w-sm leading-relaxed">
            A signature talk accelerator by Michelle Fragias — speaker, communication coach and Truth Activator helping leaders speak, lead and impact the world with their voice.
          </p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/60">Program</div>
          <ul className="mt-4 space-y-2 text-[14.5px] text-white/85">
            <li><a href="#program" className="hover:text-[#e6c88a]">What&apos;s inside</a></li>
            <li><a href="#schedule" className="hover:text-[#e6c88a]">Schedule</a></li>
            <li><a href="#show-night" className="hover:text-[#e6c88a]">Show Night</a></li>
            <li><a href="#investment" className="hover:text-[#e6c88a]">Investment</a></li>
            <li><a href="#faq" className="hover:text-[#e6c88a]">FAQ</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/60">Connect</div>
          <ul className="mt-4 space-y-2 text-[14.5px] text-white/85">
            <li><a href="mailto:michelle@michellefragias.com" className="inline-flex items-center gap-2 hover:text-[#e6c88a]"><Mail size={15} /> michelle@michellefragias.com</a></li>
            <li><a href={SITE.instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#e6c88a]"><Instagram size={15} /> Instagram</a></li>
            <li><a href={SITE.linkedinUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#e6c88a]"><Linkedin size={15} /> LinkedIn</a></li>
            <li><a href={SITE.bookACallUrl} target="_blank" rel="noreferrer" className="hover:text-[#e6c88a]">Book a Call</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-wrap gap-3 items-center justify-between text-[12.5px] text-white/55">
          <div>© {new Date().getFullYear()} Michelle Fragias. All rights reserved.</div>
          <div>Take The Stage — A Signature Talk Accelerator</div>
        </div>
      </div>
    </footer>
  );
}
